class o {
  constructor(e, t) {
    this.quill = e, this.options = t, this.range = null, this.quill.getModule("toolbar").addHandler("image", this.selectLocalImage.bind(this)), this.handleDrop = this.handleDrop.bind(this), this.handlePaste = this.handlePaste.bind(this), this.quill.root.addEventListener("drop", this.handleDrop, !1), this.quill.root.addEventListener("paste", this.handlePaste, !1);
  }
  selectLocalImage() {
    this.range = this.quill.getSelection(), this.range && (this.fileHolder = document.createElement("input"), this.fileHolder.setAttribute("type", "file"), this.fileHolder.setAttribute("accept", "image/*"), this.fileHolder.setAttribute("style", "visibility:hidden"), this.fileHolder.onchange = this.fileChanged.bind(this), document.body.appendChild(this.fileHolder), this.fileHolder.click(), window.requestAnimationFrame(() => {
      document.body.removeChild(this.fileHolder);
    }));
  }
  handleDrop(e) {
    if (e.stopPropagation(), e.preventDefault(), e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
      if (document.caretRangeFromPoint) {
        const s = document.getSelection(), i = document.caretRangeFromPoint(e.clientX, e.clientY);
        s && i && s.setBaseAndExtent(i.startContainer, i.startOffset, i.startContainer, i.startOffset);
      } else {
        const s = document.getSelection(), i = document.caretPositionFromPoint(e.clientX, e.clientY);
        s && i && s.setBaseAndExtent(i.offsetNode, i.offset, i.offsetNode, i.offset);
      }
      this.range = this.quill.getSelection();
      const t = e.dataTransfer.files[0];
      setTimeout(() => {
        this.range = this.quill.getSelection(), this.readAndUploadFile(t);
      }, 0);
    }
  }
  handlePaste(e) {
    const t = e.clipboardData || window.clipboardData;
    if (t && (t.items || t.files)) {
      const s = t.items || t.files, i = /^image\/(jpe?g|gif|png|svg|webp)$/i;
      for (let l = 0; l < s.length; l += 1)
        if (i.test(s[l].type)) {
          const a = s[l].getAsFile ? s[l].getAsFile() : s[l];
          a && (this.range = this.quill.getSelection(), e.preventDefault(), setTimeout(() => {
            this.range = this.quill.getSelection(), this.readAndUploadFile(a);
          }, 1));
        }
    }
  }
  readAndUploadFile(e) {
    let t = !1;
    const s = new FileReader();
    s.addEventListener("load", () => {
      if (!t) {
        const i = s.result;
        this.insertBase64Image(i);
      }
    }, !1), e && s.readAsDataURL(e), this.options.upload(e).then((i) => {
      this.insertToEditor(i);
    }, () => {
      t = !0, this.removeBase64Image();
    });
  }
  fileChanged() {
    const e = this.fileHolder.files[0];
    this.readAndUploadFile(e);
  }
  insertBase64Image(e) {
    const { range: t } = this;
    this.quill.insertEmbed(t.index, "imageBlot", `${e}`, "user");
  }
  insertToEditor(e) {
    const { range: t } = this;
    this.quill.deleteText(t.index, 3, "user"), this.quill.insertEmbed(t.index, "image", `${e}`, "user"), t.index += 1, this.quill.setSelection(t, "user");
  }
  removeBase64Image() {
    const { range: e } = this;
    this.quill.deleteText(e.index, 3, "user");
  }
}
export {
  o as ImageUploader
};
